import React from 'react';
import {
  Box,
  Container,
  Typography,
  LinearProgress,
  Paper,
  Stack,
} from '@mui/material';
import { Engineering, AccessTime, Email } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  textAlign: 'center',
  background: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
}));

const MaintenancePage = ({ messageStr }: { messageStr: React.ReactNode }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: 2,
      }}
    >
      <Container maxWidth='sm'>
        <StyledPaper elevation={3}>
          <Stack spacing={3} alignItems='center'>
            <Engineering
              sx={{
                fontSize: 100,
                color: 'primary.main',
                animation: 'spin 4s linear infinite',
                '@keyframes spin': {
                  '0%': {
                    transform: 'rotate(0deg)',
                  },
                  '100%': {
                    transform: 'rotate(360deg)',
                  },
                },
              }}
            />

            <Typography
              variant='h3'
              component='h1'
              fontWeight='bold'
              color='primary'
            >
              Under Maintenance
            </Typography>

            <Typography
              variant='h6'
              color='text.secondary'
              sx={{ maxWidth: '80%' }}
            >
              {messageStr}
            </Typography>

            <Box sx={{ width: '100%', mt: 3, mb: 2 }}>
              <LinearProgress
                variant='indeterminate'
                sx={{
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: 'rgba(0,0,0,0.1)',
                  '& .MuiLinearProgress-bar': {
                    borderRadius: 3,
                  },
                }}
              />
            </Box>

            <Stack
              direction='row'
              spacing={1}
              alignItems='center'
              sx={{ mt: 2 }}
            >
              <AccessTime sx={{ color: 'text.secondary' }} />
              <Typography variant='body1' color='text.secondary'>
                Expected to be back online in a few days
              </Typography>
            </Stack>

            <Box
              sx={{
                mt: 4,
                pt: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
                width: '100%',
              }}
            >
              <Stack
                direction='row'
                spacing={1}
                alignItems='center'
                justifyContent='center'
              >
                <Email sx={{ fontSize: 20, color: 'text.secondary' }} />
                <Typography variant='body2' color='text.secondary'>
                  Questions? Contact us at rbasford@npsfoundation.org
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </StyledPaper>
      </Container>
    </Box>
  );
};

export default MaintenancePage;
